import { useTranslation } from 'react-i18next'
import { formatPrice } from '../../../utils/utils'
import { useCheckout } from '../../../components/Checkout/CheckoutContext'
import { SHIPPING_OPTION_FREE } from '../../../stores/shippingStore/shipping.consts'
import { useLastGroupPricing } from './useLastGroupPricing'

// Free-shipping copy lives below the checkout button, independent of the promo
// banner: "Free shipping applied" once the threshold is met, otherwise the
// (dynamic) threshold the order needs to reach. Only shown when free shipping
// is the selected option — there's nothing to say about it otherwise.
// Reads the last known pricing: on mobile the bag is as tall as its content, so
// dropping this line mid-refetch shifts every row down and back up.
export function useFreeShippingMessage(): string | null {
  const { t } = useTranslation()
  const groupPricing = useLastGroupPricing()
  const { selectedShippingOptionName } = useCheckout()

  if (!groupPricing) return null
  if (selectedShippingOptionName !== SHIPPING_OPTION_FREE) return null

  const { currency, shippingBuyoverData } = groupPricing
  if (!shippingBuyoverData) return null

  return shippingBuyoverData.applied
    ? t('order.cart_free_shipping_applied')
    : t('order.checkout.payment_summary_rows.free_shipping_over', {
        v1: formatPrice(shippingBuyoverData.buyOverPrice, currency),
      })
}
